import { Notify } from "vant";
import axios from "axios";
import VueCookie from "vue-cookie";
import Vue from "vue";
import store from "../../store/index";
import router from "../../router/index";

const securedPaths = ["/mobile/paymentsTest", "/mobile/payments"];

function isSecuredPath(path) {
  return securedPaths.includes(path);
}

let params = new URL(document.location).searchParams;

let baseURL;

let domainTitleMap = {
  "pay.zhaofupay.com": "https://i.zhaofupay.com",
  "runn-f.test": "/", // 本機測試
  "running.etmart2.test": "/", // 本機測試
  "running.etmart2.com": "/", // 測試機測試
  "running.etmart3.com": "/", // 測試機測試
  "43.139.102.188": "http://43.139.102.188", // 聚合支付
  "43.138.153.196": "http://43.138.153.196", // 海淘
  "122.152.225.41": "http://122.152.225.41", // 天運
  "119.91.195.29": "http://119.91.195.29", // Li
  "42.194.148.159": "http://42.194.148.159", // Li
  "101.33.250.39": "http://101.33.250.39", // Li
  "119.91.48.139": "http://119.91.48.139", // Li
  "119.91.58.34": "http://119.91.58.34", // Li
  "42.193.130.202": "http://42.193.130.202", // Li
  "150.109.117.219": "http://150.109.117.219", // Li
  "119.28.73.52": "http://119.28.73.52", // Li
  "193.112.146.26": "http://193.112.146.26", // Li
  "43.155.13.226": "http://43.155.13.226",
  "43.129.64.215": "http://43.129.64.215",
  "150.109.61.55": "http://150.109.61.55",
  "101.32.177.157": "http://101.32.177.157",
  "47.243.93.168": "http://47.243.93.168",
  "47.239.136.97": "http://47.239.136.97",
  "119.28.31.200": "http://119.28.31.200",
  "129.226.121.148": "http://129.226.121.148",
  "47.83.153.10": "http://47.83.153.10",
  "cn2.hdxa1110.com": "http://cn2.hdxa1110.com", // Li
};

let bU = domainTitleMap[document.domain];

function isDomainAnIP() {
  const domain = document.domain;
  const ipRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;
  return ipRegex.test(domain);
}
if (isDomainAnIP()) {
  bU = document.location.origin;
}

baseURL = bU || "https://888.ffb252.com";

axios.defaults.baseURL = baseURL;
axios.defaults.headers.common.Authorization =
  "Bearer " + localStorage.getItem("token");
if (params.get("id") && params.get("token")) {
  axios.defaults.headers.common["id"] = params.get("id");
  axios.defaults.headers.common.Authorization = "Bearer " + params.get("token");
}

let request = [];
const denied = JSON.parse(localStorage.getItem("dlasdla"));
const codeList = {
  BINDFA: 10016,
};

axios.interceptors.request.use(
  async (config) => {
    if (
      store.state.selfData &&
      store.state.selfData.on_duty_ds &&
      config.url != "/mobile/self"
    ) {
      store.dispatch("useIdleTimeout", true);
    }

    const urlPath = config.url.split("?")[0];

    if (router.history.current.name === "goUrl") {
      return config;
    }

    // if (
    //   store.state.version &&
    //   store.state.currentVersion !== store.state.version
    // ) {
    //   Notify({
    //     duration: 0,
    //     message: "为了最新体验，请重新整理或重启应用。",
    //     type: "danger",
    //   });
    //   return Promise.reject(new Error("版本不一致"));
    // }

    if (
      (VueCookie.get("dlasdla") && VueCookie.get("dlasdla") === "asdq123") ||
      (denied && denied.expires > new Date().getTime())
    ) {
      Notify({
        message: "拒绝访问-" + VueCookie.get("userIp"),
        type: "danger",
      });
      return Promise.reject(new Error("封鎖訪問"));
    }

    if (isSecuredPath(urlPath)) {
      try {
        const hmacRes = await axios.get("/mobile/hmac", {
          headers: {
            "x-verify-path": urlPath,
          },
        });

        if (hmacRes.data.code === 0) {
          const token = hmacRes.data.data.token;
          config.headers["x-verify-token"] = token;
        } else {
          Notify({
            type: "danger",
            message: "驗證失敗，請稍後再試",
          });
          return Promise.reject(new Error("HMAC 驗證失敗"));
        }
      } catch (err) {
        Notify({
          type: "danger",
          message: "無法取得驗證資訊，請檢查網路",
        });
        return Promise.reject(err);
      }
    }

    store.dispatch("setWaitQuest", true);
    store.dispatch("setLoadding", true);
    request.push(urlPath);
    return config;
  },
  () => {
    Notify({
      message: "网络异常,请联系客服",
      type: "danger",
    });
  }
);

axios.interceptors.response.use(
  (res) => {
    request.splice(request.indexOf(res.config.url.split("?")[0]), 1);
    if (request.length === 0) {
      store.dispatch("setReload", false);
      store.dispatch("setLoadding", false);
      store.dispatch("setWaitQuest", false);
    }

    if (res.data.code === codeList.BINDFA) {
      store.dispatch("bindFA", true);
    }

    if (res.data.code === 9999999) {
      const date = new Date();
      const min = date.getMinutes();

      fetch(`http://ip-api.com/json`)
        .then((res) => res.json())
        .then((data) => {
          VueCookie.set("userIp", data.query);
        });

      VueCookie.set("dlasdla", "asdq123", { expires: "10m" });
      localStorage.setItem(
        "dlasdla",
        JSON.stringify({
          have: true,
          expires: date.setMinutes(min + 10),
        })
      );
    }

    if (res.data.code === 10001) {
      store.dispatch("disconnectPusher");
      store.commit("CLEARNSELF");
      Notify({ message: res.data.message, type: "danger" });
      axios.defaults.headers.common.Authorization = "";
      // VueCookie.delete("token");
      localStorage.removeItem("token");
      if (router.history.current.name !== "userLogin") {
        router.push("/userLogin");
      }
      return res;
    }

    if (res.data.code === 50000) {
      return res;
    }

    if (res.data.code !== 0) {
      Notify({
        message: res.data.message,
        type: "danger",
      });
      return res;
    }

    return res;
  },
  (err) => {
    setTimeout(() => {
      store.dispatch("setLoadding", false);
      request = [];
    }, 1500);
    try {
      let eee = err.toJSON();
      if (eee.code == "ECONNABORTED") {
        return Promise.reject(err);
      }
    } catch {
      console.log(err);
    }
    if (!err.response) {
      fetch(`http://ip-api.com/json`)
        .then((res) => res.json())
        .then((data) => {
          Notify({
            showClose: true,
            message: `请先检查您的网络-${err.toJSON().config.url}-${
              data.query
            }\n${err.toJSON().message}`,
            type: "danger",
          });
        })
        .catch(() => {
          Notify({
            showClose: true,
            message: `请先检查您的网络-${err.toJSON().config.url}\n${
              err.toJSON().message
            }`,
            type: "danger",
          });
        });

      store.dispatch("setLoadding", false);
      return Promise.reject(err);
    }

    request.splice(request.indexOf(err.config.url.split("?")[0]), 1);
    if (request.length === 0) {
      store.dispatch("setReload", false);
      store.dispatch("setLoadding", false);
      store.dispatch("setWaitQuest", false);
    }

    if (err.response.status === 500) {
      Notify({ showClose: true, message: "连线失败", type: "danger" });
      return Promise.reject(err);
    }

    if (err.response.status === 429) {
      Notify({
        showClose: true,
        message: "请求次数过多，已达到限制速率门槛",
        type: "danger",
      });
    }

    if (err.response.status === 430) {
      Notify({
        showClose: true,
        message: "操作速度太快了，请勿频繁刷新页面！",
        type: "danger",
      });
    }
    return Promise.reject(err);
  }
);

const retryPaths = ["/mobile/chat", "/mobile/self"];

// retry 三次
export async function axiosWithRetry(config, retryCount = 0) {
  const MAX_RETRIES = 3;
  const TIMEOUT = 3000;

  try {
    const res = await axios({
      ...config,
      timeout: TIMEOUT,
    });
    return res;
  } catch (err) {
    const isTimeout =
      err.code === "ECONNABORTED" || err.code === "ERR_CANCELED";

    const url = config.url || "";
    const matchedPath = retryPaths.find((path) => url.startsWith(path));

    if (isTimeout && matchedPath && retryCount < MAX_RETRIES) {
      console.warn(`⚠️ Retry #${retryCount + 1} for ${url}`);
      return axiosWithRetry(config, retryCount + 1);
    }

    return Promise.reject(err);
  }
}

Vue.prototype.$httpRetry = axiosWithRetry;
